import './UserMenu.scss';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { Authentication } from '../api/Authentication';
import { useAuth } from '../contexts/auth';
import { useToasts } from '../contexts/toasts';
import Cookies from 'js-cookie';
import Avatar from './Avatar';

type ToggleProps = {
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}
type Ref = HTMLButtonElement;

const CustomToggle = React.forwardRef<Ref, ToggleProps>(({ children, onClick }, ref) => (
  <button
    type="button"
    ref={ref}
    onClick={onClick}
    className="user-menu-toggle"
  >
    {children}
  </button>
));

type MenuProps = {
  className: string;
}

export default function UserMenu({ className }: MenuProps) {
  const { showToast } = useToasts();
  const { setToken, loggedUser, refreshToken } = useAuth();
  const navigate = useNavigate();

  const logout = () => {
    let newRefreshToken = refreshToken;
    
    if(!refreshToken){
      newRefreshToken = Cookies.get(window.__env.REF_TOKEN_NAME || "vespa-ref-token");
    }

    Authentication.logout(newRefreshToken!)
      .then(
        () => {
          Cookies.remove(window.__env.TOKEN_NAME);
          setToken!(null);
          navigate('/login');
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast!('logout-error', message, `Logout Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const accountSection = () => navigate('/account');

  return (
    <Dropdown className={`user-menu ${className}`}>
      <Dropdown.Toggle as={CustomToggle}>
        <Avatar user={loggedUser!} size="sm" />
        <span className="ms-2">{loggedUser?.username}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        <Dropdown.Item onClick={accountSection}>
          <FontAwesomeIcon icon={solid('user')} fixedWidth />
          <span className="ms-3">Account</span>
        </Dropdown.Item>

        {/* <Dropdown.Divider /> */}

        <Dropdown.Item onClick={logout}>
          <FontAwesomeIcon icon={solid('sign-out')} fixedWidth />
          <span className="ms-3">Logout</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}